import { __rest } from "tslib";
import * as React from 'react';
export var RowSelectVariant;

(function (RowSelectVariant) {
  RowSelectVariant["radio"] = "radio";
  RowSelectVariant["checkbox"] = "checkbox";
})(RowSelectVariant || (RowSelectVariant = {}));

export var SelectColumn = function SelectColumn(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      className = _a.className,
      _a$onSelect = _a.onSelect,
      onSelect = _a$onSelect === void 0 ? null : _a$onSelect,
      selectVariant = _a.selectVariant,
      props = __rest(_a, ["children", "className", "onSelect", "selectVariant"]);

  return React.createElement(React.Fragment, null, React.createElement("label", null, React.createElement("input", Object.assign({}, props, {
    type: selectVariant,
    onChange: onSelect
  }))), children);
};
SelectColumn.displayName = 'SelectColumn';